import React from 'react';
import {FormattedMessage} from 'react-intl';

export const ReviewMessages = [<FormattedMessage id={'labels.REVIEW_MESSAGE_OTP'}/>,
    <FormattedMessage id={'labels.REVIEW_MESSAGE_ISD_CODE'}/>,
    <FormattedMessage id={'labels.REVIEW_MESSAGE_DETAILS_CANNOT_UPDATE'}/>]

export const StartDateWarningMessage = 'alerts.START_DATE_WARNING_MESSAGE';
export const InvalidProductWarning = 'alerts.INVALID_PRODUCT_WARNING';
export const GuarantorWarningMessage = 'alerts.GUARANTOR_WARNING_MESSAGE';
